import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { TagContainer, GradientText } from "./AssetClassTag.styles";
import { LineChartUpIcon } from "assets/icons";
import { Bitcoin } from "lucide-react";

const GradientCoins = (props) => (
  <Bitcoin {...props} stroke="url(#coin-gradient)">
    <defs>
      <linearGradient id="coin-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#e8d07a" />
        <stop offset="100%" stopColor="#5312d6" />
      </linearGradient>
    </defs>
  </Bitcoin>
);
const AssetClassTag = ({ assetClass, className }) => {
  const isCrypto = useMemo(() => {
    return assetClass?.toLowerCase().includes("crypto");
  }, [assetClass]);

  return (
    <TagContainer className={className}>
      {isCrypto ? (
        <GradientCoins size={12} strokeWidth={2.5} />
      ) : (
        <img src={LineChartUpIcon} alt="Equity" width="12" height="12" />
      )}
      <GradientText>{assetClass}</GradientText>
    </TagContainer>
  );
};

AssetClassTag.propTypes = {
  assetClass: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default AssetClassTag;
